import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import keycloakAuthSagas from './keycloakAuth/saga';

export default function* rootSaga() {
  yield all([
    authSagas(),
    keycloakAuthSagas()
  ]);
}
